// https://github.com/vercel/next.js/blob/v13.5.11/packages/next/src/client/legacy/image.tsx

import { normalizePathTrailingSlash } from 'next/dist/client/normalize-trailing-slash'
import { ImageLoaderProps } from 'next/image'
import { imageConfigDefault } from 'next/dist/shared/lib/image-config'

// default loader customized to load from CDN
export default function defaultLoader({
  src,
  width,
  quality
}: ImageLoaderProps): string {
  const config = imageConfigDefault
  if (process.env.NODE_ENV !== 'production') {
    const missingValues = []

    // these should always be provided but make sure they are
    if (!src) missingValues.push('src')
    if (!width) missingValues.push('width')

    if (missingValues.length > 0) {
      throw new Error(
        `Next Image Optimization requires ${missingValues.join(
          ', '
        )} to be provided. Make sure you pass them as props to the \`next/image\` component. Received: ${JSON.stringify(
          { src, width, quality }
        )}`
      )
    }

    if (src.startsWith('//')) {
      throw new Error(
        `Failed to parse src "${src}" on \`next/image\`, protocol-relative URL (//) must be changed to an absolute URL (http:// or https://)`
      )
    }
  }

  if (src.endsWith('.svg') && !config.dangerouslyAllowSVG) {
    // Special case to make svg serve as-is to avoid proxying
    // through the built-in Image Optimization API.
    return src
  }

  const assetPrefix =
    process.env.NODE_ENV === 'development'
      ? ''
      : 'https://cdn.bestfoodtrucks.com'

  return `${assetPrefix}${normalizePathTrailingSlash(
    config.path!
  )}?url=${encodeURIComponent(src)}&w=${width}&q=${quality || 75}`
}
